<template>
    <main>
        <!-- render all articles for a sitemap -->
        <div class="sitemap">
            <h1 class="sitemap__title">
                Sitemap
            </h1>

            <ul class="sitemap__list">
                <li
                    v-for="storyList in stories"
                    :key="storyList.full_slug || storyList.name"
                    class="sitemap__list-title"
                >
                    <h2 class="sitemap__list-title">
                        <a
                            v-if="storyList.full_slug"
                            :href="storyList.full_slug"
                        >
                            {{ storyList.name }}
                        </a>
                        <span v-else>
                            {{ storyList.name }}
                        </span>
                    </h2>

                    <ul class="sitemap__sublist">
                        <li
                            v-for="story in storyList.stories"
                            :key="story.full_slug"
                            class="sitemap__sublist-item"
                        >
                            <a
                                class="sitemap__sublist-link"
                                :href="story.full_slug"
                            >
                                {{ story.name }}
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </main>
</template>

<script setup>
const { data: stories } = await useAsyncData('page-sitemap', () => $fetch('/api/page-sitemap'))
</script>

<style lang="scss" scoped>
@use '@vemedia/bcn-components/scss/responsive' as *;

.sitemap {
    display: flex;
    flex-direction: column;
    padding: 40px 32px;

    @include tablet {
        padding: 40px 0;
    }

    &__list {
        display: grid;
        grid-template-columns: 1fr;
        gap: 20px;
        list-style-type: none;

        @include tablet {
            grid-template-columns: 1fr 1fr;
        }

        @include desktop {
            grid-template-columns: 1fr 1fr 1fr;
        }
    }

    &__title {
        padding-bottom: 2rem;
    }

    &__list-title {
        font-size: 1.5rem;
        padding-bottom: 1rem;
        text-transform: capitalize;

        a {
            color: inherit;

            &:hover {
                text-decoration: underline;
            }
        }
    }

    &__sublist {
        display: flex;
        flex-direction: column;
        list-style-type: none;
    }

    &__sublist-link {
        color: #000;
        text-decoration: none;
        font-size: 1rem;

        &:hover {
            text-decoration: underline;
        }
    }
}
</style>
